module.exports = __webpack_public_path__ + "static/media/1027935.a606920c.png";